import React, { useState } from 'react';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import { Tooltip, Badge, IconButton, Checkbox } from '@material-ui/core';
import { Datatable } from '../../components';
import { InfoOutlined } from '@material-ui/icons';
import { CompleteTradeButton } from './components/CompleteTradeButton';
import { RevertToActiveButton } from './components/RevertToActiveButton';
import { SendSMSActions } from './components/SendSMSActions';
import {formatEasternDateTime, formatEasternDateTimeFromUtc,} from '../../utils/DateUtil';

export const TradesInitiated = ({
  data,
  updateStatus,
  tradesProcessing,
  tradesLoading,
  toggleJobModal,
  sendCodeExchangeSMS,
  sendingSms,
}) => {
  const [selected, setSelected] = useState([]);

  const PaddedBadge = withStyles((theme) => ({
    root: {
      marginLeft: theme.spacing(2),
    },
  }))(Badge);

  const formatTimestamp = formatEasternDateTime;

  const toggleSelected = (jobId) => {
    setSelected((prev) =>
      prev.includes(jobId)
        ? prev.filter((id) => id !== jobId)
        : [...prev, jobId]
    );
  };

  const tableConfig = [
    {
      heading: 'Inspect',
      key: 'id',
      headingStyles: { width: '25px' },
      formatter: (val) => (
        <IconButton
          aria-label="inspect"
          onClick={() => {
            toggleJobModal(val);
          }}
        >
          <InfoOutlined />
        </IconButton>
      ),
    },
    {
      sortable: true,
      heading: 'Status',
      key: 'status',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Participant Name',
      key: 'participantName',
      formatter: (val, row) =>
        row?.expirationCount > 0 ? (
          <span>
            {val}
            <Tooltip title="Recycle Count">
              <PaddedBadge badgeContent={row.expirationCount} color="error" />
            </Tooltip>
          </span>
        ) : (
          val
        ),
    },
    {
      heading: 'Product',
      sortable: true,
      key: 'product',
      formatter: (val) => val,
    },
    { heading: 'Type', sortable: true, key: 'type', formatter: (val) => val },
    {
      sortable: true,
      heading: 'CET Sent',
      key: 'codeSent',
      formatter: formatEasternDateTime,
    },
    {
      sortable: true,
      heading: 'Code Received',
      key: 'codeReceived',
      formatter: formatEasternDateTimeFromUtc,
    },
    {
      heading: 'Send Code Exchange',
      key: 'id',
      formatter: (val, row) =>
        row.status === 'active' ? (
          <Checkbox
            color="primary"
            checked={selected.includes(val)}
            inputProps={{ 'aria-label': 'select for code exchange' }}
            onClick={() => toggleSelected(val)}
          />
        ) : null,
    },
    {
      heading: 'Revert to Active',
      key: 'id',
      formatter: (val, row) =>
        row.status === 'readyForCode' ? (
          <RevertToActiveButton
            jobId={val}
            loading={tradesProcessing.includes(val)}
            updateStatus={updateStatus}
          />
        ) : null,
    },
    {
      heading: 'Complete Trade',
      key: 'id',
      formatter: (val) => (
        <CompleteTradeButton
          jobId={val}
          loading={tradesProcessing.includes(val)}
          updateStatus={updateStatus}
        />
      ),
    },
  ];

  return (
    <Datatable
      loading={tradesLoading}
      tableHeading="Trades Initiated"
      defaultSortColumn="created"
      defaultSortDirection="desc"
      data={data}
      tableConfig={tableConfig}
      paginationLeft={true}
      footerContent={
        <SendSMSActions
          hideInviteSms
          loading={sendingSms}
          disabled={selected.length === 0}
          sendCodeExchangeSMS={() => {
            sendCodeExchangeSMS(selected);
            setSelected([]);
          }}
        />
      }
    />
  );
};
